import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import moment from "moment";
import RowDataTableModal from "../../../Component/Modal/RowDataTableModal";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageSubscription = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    startDate: "",
    endDate: "",
    cityNames: [],
    subscriptionType: "",
  });
  const [subscriptionID, setSubscriptionID] = useState("");
  const [cityList, setCityList] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpenPropertyType, setIsDropdownOpenPropertyType] =
    useState(false);
  const dropdownRef = useRef(null);
  const dropdownRefPropertyType = useRef(null);
  const navigate = useNavigate();

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const [filterText, setFilterText] = useState("");
  const [filteredInformation, setFilteredInformation] = useState([]);

  const [cityIdForFilter, setCityIdforFilter] = useState("");

  const fetchSubscriptions = async () => {
    try {
      const res = await HomeService.getSubscriptions();

      console.log("IUY38", res.data);
      if (res?.status) {
        if (userCity) {
          setSubscriptions(
            res.data
              .filter((item) => item?.city[0]._id === userCity)
              .sort((d1, d2) => new Date(d2.date) - new Date(d1.date)) || [],
          );
        } else {
          setSubscriptions(
            res.data.sort((d1, d2) => new Date(d2.date) - new Date(d1.date)) ||
              [],
          );
        }
      } else {
        toast.error("Failed to fetch subscriptions.");
      }
    } catch (error) {
      toast.error("Error fetching subscriptions.");
      console.error("Error fetching subscriptions:", error);
    } finally {
      setLoading(false);
    }
  };

  const [cities, setCities] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.status) {
        setAllCities(res?.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
          fetchLocalities(userCity);
        } else {
          setCities(res.data);
        }
      } else {
        toast.error("Failed to fetch cities.");
      }
    } catch (error) {
      toast.error("Error fetching cities.");
      console.error("Error fetching cities:", error);
    }
  };

  const [localities, setLocalities] = useState([]);

  // Fetch localities
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      // console.log("HYT71", res);

      if (res?.data) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const [propertyTypes, setPropertyTypes] = useState([]);
  // Fetch PropertyType
  const fetchPropertyTypes = async () => {
    try {
      const res = await HomeService.getPropertyTypes();
      console.log("MNB83", res.data);

      if (res?.status) {
        setPropertyTypes(res.data);
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const handleEdit = (row) => {
    setIsEdit(true);

    const editSection = document.getElementById("edit-section");
    if (editSection) {
      editSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    const subscriberType =
      row?.userDetails?.type === "basic" ? "basic" : "premium";
    setUserType(subscriberType);
    fetchUserListByType(subscriberType);

    setSubscriptionID(row._id);
    fetchLocalities(row.city.map((city) => city._id)[0]);
    setEditData({
      ...row,
      userId: row?.userDetails?._id,
      startDate: row?.startDate?.split("T")[0],
      endDate: row?.endDate?.split("T")[0],
      date: row?.date?.split("T")[0],
      city: row?.city?.map((city) => city._id),
      locality: row?.locality?.map((item) => item._id),
      propertyType: row?.propertyType?.map((item) => item._id),
      subscriptionType: row?.subscriptionType || "",
    });
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === true ? false : true;
      await HomeService.updateSubscriptionStatus(id, { status: newStatus });
      fetchSubscriptions();

      // toast.success(`Subscription status updated to ${newStatus}!`);
    } catch (error) {
      toast.error("Failed to update subscription status.");
      console.error("Error updating status:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editData?.startDate && editData?.endDate) {
      const start = new Date(editData?.startDate);
      const end = new Date(editData?.endDate);

      if (start > end) {
        toast.error("Start date cannot be greater than end date!");
        return;
      }
    }
    try {
      const updatedData = {
        userId: editData.userId,
        cityId: editData.city,
        locality: editData.locality,
        propertyType: editData.propertyType,
        // price: parseInt(editData.price),
        price: Number(editData?.price),
        startDate: editData.startDate,
        endDate: editData.endDate,
        date: editData.date,
        remarks: editData.remarks,
        subscriptionType: editData.subscriptionType || "",
      };

      console.log("GHJ175", updatedData);
      // return

      const res = await HomeService.updateSubscription(
        subscriptionID,
        updatedData,
      );

      if (res) {
        toast.success("Subscription updated successfully!");
        setIsEdit(false);
        fetchSubscriptions();
      }
    } catch (error) {
      toast.error("Failed to update subscription.");
      console.error("Error saving subscription:", error);
    }
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setEditData((prevData) => ({
      ...prevData,
      cityNames: prevData.cityNames.includes(value)
        ? prevData.cityNames.filter((city) => city !== value)
        : [...prevData.cityNames, value],
    }));
  };

  const handleLocalityChange = (e) => {
    const value = e.target.value;
    console.log("UYT172", value);

    setEditData((prevData) => ({
      ...prevData,
      locality: prevData.locality.includes(value)
        ? prevData.locality.filter((city) => city !== value)
        : [...prevData.locality, value],
    }));
    setAllSelected(false);
  };

  const handlePropertyTypeChange = (e) => {
    const value = e.target.value;
    console.log("UYT172", value);

    setEditData((prevData) => ({
      ...prevData,
      propertyType: prevData.propertyType.includes(value)
        ? prevData.propertyType.filter((city) => city !== value)
        : [...prevData.propertyType, value],
    }));
    setAllSelectedPropertyType(false);
  };

  const [allSelected, setAllSelected] = useState(false);
  const handleSelectAllLocations = (e) => {
    // console.log("JUY189", localities, locationIds, e.target.value);
    let allLocalities = localities.map((item) => item._id);
    if (allSelected) {
      allLocalities = [];
    }
    setEditData((prevData) => ({
      ...prevData,
      locality: allLocalities,
    }));
    // setLocationIds(allLocalities)
    setAllSelected(!allSelected);
  };

  const [allSelectedPropertyType, setAllSelectedPropertyType] = useState(false);
  const handleSelectAllPropertyType = (e) => {
    // console.log("JUY189", localities, locationIds, e.target.value);
    let allPropertyTypes = propertyTypes.map((item) => item._id);
    if (allSelectedPropertyType) {
      allPropertyTypes = [];
    }
    setEditData((prevData) => ({
      ...prevData,
      propertyType: allPropertyTypes,
    }));
    // setLocationIds(allLocalities)
    setAllSelectedPropertyType(!allSelectedPropertyType);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: `Delete Subscription?`,
      text: "Are you sure you want to delete this Subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteSubscription(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Subscription has been deleted.", "success");
          fetchSubscriptions();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Subscription.", "error");
      }
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleDropdownPropertyType = () => {
    setIsDropdownOpenPropertyType(!isDropdownOpenPropertyType);
  };

  const [selectedLocalitiesList, setSelectedLocalitiesList] = useState([]);
  const [isLocalitiesModalOpen, setIsLocalitiesModalOpen] = useState(false);
  const handleLocalitiesView = (data) => {
    setSelectedLocalitiesList(data);
    setIsLocalitiesModalOpen(true);
  };

  // Excel Export Function
  const exportToExcel = () => {
    try {
      const dataToExport = filterText ? filteredInformation : subscriptions;

      if (dataToExport.length === 0) {
        toast.error("No data available to export!");
        return;
      }

      const exportData = dataToExport.map((item, index) => ({
        "S.No": index + 1,
        Date: moment(item?.date?.split("T")[0]).format("DD-MM-YYYY"),
        "User Name": item.userDetails?.fullName || "N/A",
        Email: item.userDetails?.email || "N/A",
        Price: item.price,
        "Subscription Type": item.subscriptionType
          ? item.subscriptionType.charAt(0).toUpperCase() +
            item.subscriptionType.slice(1)
          : "N/A",
        City: item.city[0]?.name || "N/A",
        Localities: item.locality.map((l) => l.name).join(", "),
        "Start Date": moment(item.startDate?.split("T")[0]).format(
          "DD-MM-YYYY",
        ),
        "End Date": moment(item.endDate?.split("T")[0]).format("DD-MM-YYYY"),
        "Property Types":
          item.propertyType?.map((p) => p.name).join(", ") || "N/A",
        Remarks: item.remarks || "N/A",
        Status: item.status ? "Active" : "Inactive",
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Subscriptions");

      // Auto-size columns
      const maxWidth = 50;
      const colWidths = [];
      Object.keys(exportData[0] || {}).forEach((key) => {
        const maxLength = Math.max(
          key.length,
          ...exportData.map((row) => String(row[key] || "").length),
        );
        colWidths.push({ wch: Math.min(maxLength, maxWidth) });
      });
      ws["!cols"] = colWidths;

      XLSX.writeFile(
        wb,
        `subscriptions_${moment().format("DD-MM-YYYY_HH-mm")}.xlsx`,
      );
      toast.success("Excel file downloaded successfully!");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toast.error("Failed to export to Excel!");
    }
  };

  // PDF Export Function
  const exportToPDF = () => {
    try {
      const dataToExport = filterText ? filteredInformation : subscriptions;

      if (dataToExport.length === 0) {
        toast.error("No data available to export!");
        return;
      }

      const doc = new jsPDF("landscape");

      // Add title
      doc.setFontSize(16);
      doc.setTextColor(40, 40, 40);
      doc.text("Subscriptions Report", 14, 15);

      // Add date
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.text(
        `Generated on: ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
        14,
        22,
      );

      // Prepare table data
      const tableData = dataToExport.map((item, index) => [
        index + 1,
        moment(item?.date?.split("T")[0]).format("DD-MM-YYYY"),
        item.userDetails?.fullName || "N/A",
        item.userDetails?.email || "N/A",
        item.price,
        item.subscriptionType
          ? item.subscriptionType.charAt(0).toUpperCase() +
            item.subscriptionType.slice(1)
          : "N/A",
        item.city[0]?.name || "N/A",
        item.locality
          .map((l) => l.name)
          .join(", ")
          .substring(0, 50),
        moment(item.startDate?.split("T")[0]).format("DD-MM-YYYY"),
        moment(item.endDate?.split("T")[0]).format("DD-MM-YYYY"),
        item.propertyType
          ?.map((p) => p.name)
          .join(", ")
          .substring(0, 40) || "N/A",
        item.remarks?.substring(0, 40) || "N/A",
      ]);

      const tableHeaders = [
        "S.No",
        "Date",
        "User Name",
        "Email",
        "Price",
        "Type",
        "City",
        "Localities",
        "Start Date",
        "End Date",
        "Property Types",
        "Remarks",
      ];

      doc.autoTable({
        head: [tableHeaders],
        body: tableData,
        startY: 28,
        theme: "striped",
        styles: {
          fontSize: 8,
          cellPadding: 2,
          overflow: "linebreak",
          lineColor: [200, 200, 200],
          lineWidth: 0.1,
        },
        headStyles: {
          fillColor: [133, 218, 79],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 9,
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        columnStyles: {
          0: { cellWidth: 12 },
          1: { cellWidth: 18 },
          2: { cellWidth: 22 },
          3: { cellWidth: 32 },
          4: { cellWidth: 18 },
          5: { cellWidth: 18 },
          6: { cellWidth: 18 },
          7: { cellWidth: 35 },
          8: { cellWidth: 18 },
          9: { cellWidth: 18 },
          10: { cellWidth: 30 },
          11: { cellWidth: 25 },
        },
        margin: { top: 28, left: 10, right: 10 },
      });

      // Add page numbers
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150);
        doc.text(
          `Page ${i} of ${pageCount}`,
          doc.internal.pageSize.width - 20,
          doc.internal.pageSize.height - 10,
        );
      }

      doc.save(`subscriptions_${moment().format("DD-MM-YYYY_HH-mm")}.pdf`);
      toast.success("PDF file downloaded successfully!");
    } catch (error) {
      console.error("Error exporting to PDF:", error);
      toast.error("Failed to export to PDF!");
    }
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.userDetails?.fullName || "N/A",
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) =>
        row.subscriptionType
          ? row.subscriptionType.charAt(0).toUpperCase() +
            row.subscriptionType.slice(1)
          : "N/A",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.userDetails?.email || "N/A",
      wrap: true,
    },
    {
      name: "City",
      selector: (row) => row.city[0]?.name,
      sortable: true,
    },
    {
      name: "Localities",
      cell: (row) => (
        <>
          {row?.locality.length}&nbsp;
          <i
            className="fa-solid fa-eye "
            onClick={() => handleLocalitiesView(row?.locality)}
            style={{ cursor: "pointer", color: "darkBlue", fontSize: "12px" }}
          ></i>
        </>
      ),
      wrap: true,
      align: "center",
    },
    {
      name: "Start Date",
      selector: (row) =>
        moment(row.startDate.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => moment(row.endDate.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      wrap: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.status ? "success" : "danger"}`}
          onClick={() => toggleStatus(row._id, row.status)}
        >
          {row.status ? "Active" : "Inactive"}
        </button>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const formatDateForDisplay = (date) => {
    if (!date) return ""; // Handle empty or invalid dates
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };
  const [userList, setUserList] = useState([]);
  const [userType, setUserType] = useState("premium");

  const fetchUserListByType = async (type) => {
    try {
      let response;
      if (type === "basic") {
        response = await HomeService.getBasicUsers();
      } else {
        response = await HomeService.getUsers();
      }

      const usersData = response?.data || [];
      if (userCity) {
        setUserList(
          usersData.filter(
            (item) => (item?.city?._id || item?.city) === userCity,
          ) || [],
        );
      } else {
        setUserList(usersData);
      }
    } catch (error) {
      toast.error("Failed to fetch user list.");
      console.error("Error fetching data:", error);
    }
  };

  const handleUserTypeChange = (type) => {
    setUserType(type);
    fetchUserListByType(type);
  };

  useEffect(() => {
    fetchSubscriptions();
    fetchUserListByType(userType);
    fetchCities();
    fetchPropertyTypes();
  }, []);

  const filter = () => {
    console.log("subscriptions", subscriptions);

    const filteredData = subscriptions.filter((item) => {
      const text = filterText.toLowerCase();

      // city array check
      const cityMatch = item?.city?.some((c) =>
        c?.name?.toLowerCase().includes(text),
      );

      // locality array check
      const localityMatch = item?.locality?.some((l) =>
        l?.name?.toLowerCase().includes(text),
      );

      // userDetails check
      const userMatch =
        item?.userDetails?.fullName?.toLowerCase().includes(text) ||
        item?.userDetails?.email?.toLowerCase().includes(text);

      // propertyType array check
      const propertyTypeMatch = item?.propertyType?.some((p) =>
        p?.name?.toLowerCase().includes(text),
      );

      // price check (convert number → string)
      const priceMatch = item?.price?.toString().includes(text);

      // subscriptionType check
      const subscriptionTypeMatch = item?.subscriptionType
        ?.toLowerCase()
        .includes(text);

      return (
        cityMatch ||
        localityMatch ||
        userMatch ||
        propertyTypeMatch ||
        priceMatch ||
        subscriptionTypeMatch
      );
    });

    console.log("filteredData", filteredData);
    setFilteredInformation([...filteredData]);
  };

  useEffect(() => {
    filter();
  }, [filterText]);

  const handleFilter = async () => {
    if (!cityIdForFilter) {
      toast?.error("Please Select city");
      return;
    }
    try {
      const res = await HomeService?.filterSubscription({
        city: cityIdForFilter,
      });
      console.log("filter subscription", res);
      if (res?.status) {
        setSubscriptions(res?.data);
      }
    } catch (error) {
      toast.error("Failed to filter Subscriptions.");
      console.error("Error Filtering Subscription:", error);
    }
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid edit-section">
        {isEdit ? (
          <section className="chartBox_area">
            <h2>Edit Subscription</h2>
            <hr />
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* <div className="col-md-12 mb-3">
                  <label style={{ marginRight: "15px", fontWeight: "600" }}>
                    User Type:
                  </label>
                  <div className="form-check form-check-inline" style={{ display: "inline-block", marginRight: "15px" }}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="premiumUserRadio"
                      value="premium"
                      checked={userType === "premium"}
                      onChange={() => handleUserTypeChange("premium")}
                      style={{ marginRight: "5px", cursor: "pointer" }}
                    />
                    <label className="form-check-label" htmlFor="premiumUserRadio" style={{ cursor: "pointer" }}>
                      Premium User
                    </label>
                  </div>
                  <div
                    className="form-check form-check-inline"
                    style={{ display: "inline-block" }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="basicUserRadio"
                      value="basic"
                      checked={userType === "basic"}
                      onChange={() => handleUserTypeChange("basic")}
                      style={{ marginRight: "5px", cursor: "pointer" }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="basicUserRadio"
                      style={{ cursor: "pointer" }}
                    >
                      Basic User
                    </label>
                  </div>
                </div> */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="user">
                    User<span className="text-danger">*</span>
                  </label>
                  <select
                    id="user"
                    className="form-control"
                    value={editData?.userId}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        userId: e.target.value,
                      })
                    }
                    disabled={true}
                  >
                    <option value="">Select User</option>
                    {userList.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.fullName}-<h6>{user.email}</h6>
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Amount<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    className="form-control"
                    value={editData?.price}
                    // onChange={(e) =>
                    //   setEditData({
                    //     ...editData,
                    //     price: e.target.value,
                    //   })
                    // }
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setEditData((prev) => ({
                          ...prev,
                          price: e.target.value,
                        }));
                      }
                    }}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="cities">
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={editData.city[0]}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        city: [e.target.value],
                      })
                    }
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Locality<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown" ref={dropdownRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdown}
                    >
                      {editData.locality.length === 0
                        ? "Select Localities"
                        : `${editData.locality.length} localities selected`}
                    </button>
                    {isDropdownOpen && (
                      <div className="dropdown-menu-for-city">
                        <div
                          className="form-check"
                          style={{
                            borderBottom: "solid 1px #eee",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="s_all"
                            value="all"
                            checked={allSelected}
                            onChange={handleSelectAllLocations}
                            className="form-check-input"
                          />
                          <label className="form-check-label">Select all</label>
                        </div>

                        {localities.map((city) => (
                          <div key={city._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${city._id}`}
                              value={city._id}
                              checked={editData.locality.includes(city._id)}
                              onChange={handleLocalityChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`city-${city._id}`}
                              className="form-check-label"
                            >
                              {city.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="startDate">
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    className="form-control"
                    value={editData?.startDate}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        startDate: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    End Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    className="form-control"
                    value={editData?.endDate}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        endDate: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    value={editData?.date}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        date: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Property Type */}
                <div className="col-md-6 mt-3">
                  <label>
                    Property Type<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown" ref={dropdownRefPropertyType}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdownPropertyType}
                    >
                      {editData.propertyType.length === 0
                        ? "Select Property Type"
                        : `${editData.propertyType.length} Property Type selected`}
                    </button>
                    {isDropdownOpenPropertyType && (
                      <div className="dropdown-menu-for-city">
                        <div
                          className="form-check"
                          style={{
                            borderBottom: "solid 1px #eee",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="s_all_property"
                            value="all"
                            checked={allSelectedPropertyType}
                            onChange={handleSelectAllPropertyType}
                            className="form-check-input"
                          />
                          <label className="form-check-label">Select all</label>
                        </div>

                        {propertyTypes.map((item, key) => (
                          <div key={key} className="form-check">
                            <input
                              type="checkbox"
                              id={`propertyType-${item._id}`}
                              value={item._id}
                              checked={editData.propertyType.includes(item._id)}
                              onChange={handlePropertyTypeChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`propertyType-${item._id}`}
                              className="form-check-label"
                            >
                              {item.propertyType}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="subscriptionType">Subscription Type</label>
                  <select
                    id="subscriptionType"
                    className="form-control"
                    value={editData?.subscriptionType || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        subscriptionType: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Type (None)</option>
                    <option value="basic">Basic</option>
                    <option value="premium">Premium</option>
                  </select>
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="remarks">Remarks</label>
                  <textarea
                    className="form-control"
                    value={editData?.remarks}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        remarks: e.target.value,
                      })
                    }
                    placeholder="Enter remarks (if any)"
                  ></textarea>
                </div>
              </div>

              <button
                type="submit"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                }}
                className="btn mt-3"
              >
                Save Changes
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-3"
                style={{ marginLeft: "11px" }}
                onClick={() => setIsEdit(false)}
              >
                Cancel
              </button>
            </form>
          </section>
        ) : (
          <>
            <div className="mt-5">
              <div style={headLineStyle} className="page-headline">
                Manage Subscriptions
              </div>
              <hr />

              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    style={{
                      background: "#fff",
                      border: "solid 2px #85da4f",
                      borderRadius: "13px",
                      marginRight: "10px",
                    }}
                    className="btn"
                    onClick={() => {
                      navigate("/add-subscription");
                    }}
                  >
                    Add Subscription
                  </button>

                  {/* Excel Export Button */}
                  <button
                    type="button"
                    style={{
                      background: "#28a745",
                      color: "#fff",
                      border: "none",
                      borderRadius: "13px",
                      marginRight: "10px",
                      padding: "6px 15px",
                    }}
                    className="btn"
                    onClick={exportToExcel}
                  >
                    <i className="fa-solid fa-file-excel me-2"></i>
                    Export Excel
                  </button>

                  {/* PDF Export Button */}
                  <button
                    type="button"
                    style={{
                      background: "#dc3545",
                      color: "#fff",
                      border: "none",
                      borderRadius: "13px",
                      padding: "6px 15px",
                    }}
                    className="btn"
                    onClick={exportToPDF}
                  >
                    <i className="fa-solid fa-file-pdf me-2"></i>
                    Export PDF
                  </button>
                </div>

                <div className="d-flex align-items-center">
                  <input
                    onChange={(e) => {
                      setFilterText(e?.target?.value);
                    }}
                    value={filterText}
                    placeholder="Type to Search"
                    style={{
                      border: "1px solid grey",
                      height: "35px",
                      width: "250px",
                      borderRadius: "5px",
                      padding: "0 5px",
                    }}
                  />
                  <select
                    style={{
                      border: "1px solid grey",
                      height: "35px",
                      width: "180px",
                      borderRadius: "5px",
                      padding: "0 5px",
                      marginLeft: "10px",
                    }}
                    value={cityIdForFilter}
                    onChange={(e) => {
                      setCityIdforFilter(e?.target?.value);
                    }}
                  >
                    <option value="">--Select City--</option>
                    {allCities?.length == 0 ? (
                      <option>No City Found</option>
                    ) : (
                      allCities?.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.name}
                          </option>
                        );
                      })
                    )}
                  </select>
                  <button
                    style={{
                      padding: "5px 15px",
                      borderRadius: "5px",
                      backgroundColor: "#73fc03",
                      fontWeight: "600",
                      border: "none",
                      marginLeft: "10px",
                    }}
                    onClick={() => {
                      handleFilter();
                    }}
                  >
                    Filter
                  </button>
                </div>
              </div>

              {loading ? (
                <p>Loading...</p>
              ) : (
                <section className="chartBox_area">
                  <DataTable
                    columns={columns}
                    data={filterText ? filteredInformation : subscriptions}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                  <RowDataTableModal
                    isOpen={isLocalitiesModalOpen}
                    closeModal={() => setIsLocalitiesModalOpen(false)}
                    data={selectedLocalitiesList}
                    title="Localities"
                    type="localities"
                  />
                </section>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageSubscription;
